import { INITIAL_APP_POLICY, INITIAL_PRIVACY_POLICY } from "./types";

const initiate = {
    privacy: "",
    app: "",
}

const PolicyReducer = (state = initiate, action) => {
    switch (action.type) {
        case INITIAL_APP_POLICY: 
            return {
                ...state,
                ...action.payload
            };
        case INITIAL_PRIVACY_POLICY: 
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export default PolicyReducer;